@if (type() === 'duotone') {
  <i
    [ngbTooltip]="tooltip()"
    class="ki-{{ type() }} ki-{{ name() }}{{ class() ? ' ' + class() : '' }}"
  >
    @for (i of [].constructor(pathsNumber); track i; let idx = $index) {
      <span class="path{{ idx + 1 }}"></span>
    }
  </i>
}
@if (type() !== 'duotone') {
  <i
    [ngbTooltip]="tooltip()"
    class="ki-{{ type() }} ki-{{ name() }}{{ class() ? ' ' + class() : '' }}"
  ></i>
}
